import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

import * as rdStationActions from '../../../store/actions/rd-station';
import { UserActions } from '../../../store/actions/users';

const SettingsRDStation = (props) => {
  const bot = useSelector((state) => state?.bots?.bot);
  const user = useSelector((state) => state?.users?.signedUser);
  const authData = useSelector((state) => state?.rdStation?.authData);
  const [authState, setAuthState] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(UserActions.me());
  }, []);

  useEffect(() => {
    return () => {
      dispatch(rdStationActions.resetAuthData());
      dispatch(UserActions.me());
    };
  }, []);

  useEffect(() => {
    // updateUser
    if (bot) {
      const { rdStation } = bot?.settings;
      if (rdStation && !isEmpty(rdStation) && !isEmpty(rdStation.auth)) {
        const { auth } = rdStation;
        setAuthState(auth);
      }
    }
  }, [bot]);

  useEffect(() => {
    if (authData && !isEmpty(authData)) {
      setAuthState(authData);
    }
  }, [authData]);

  const onClickLoginButton = () => {
    dispatch(rdStationActions.rdStationLogin());
  };

  const onClickGenerateTokenButton = () => {
    if (user?.rdOAuthCode) {
      const data = {
        code: user.rdOAuthCode,
        botId: bot._id,
      };
      dispatch(rdStationActions.generateAccessToken(data));
    }
  };

  const onClickRemoveTokenButton = () => {
    if (authState) {
      const { _id: botId } = bot;
      dispatch(rdStationActions.deleteAccessToken({ botId }));
      dispatch(UserActions.me());
      setAuthState(null);
    }
  };

  const renderCustomSubTitle = () => {
    const style = { fontSize: 14 };
    let text = 'Conectado';
    if (!user?.rdOAuthCode && !authState) {
      text = 'Faça integração com RD Station para ativar essa funcionalidade.';
    } else if (!authState) {
      text = 'Gere um token para utilizar os blocos de integração.';
    }

    return <p style={style}>{text}</p>;
  };

  const renderLoginButton = () => {
    if (user?.rdOAuthCode || authState) {
      return false;
    }

    return (
      <button
        className="btn-blue-save"
        type="button"
        onClick={onClickLoginButton}
      >
        integrar com RD Station
      </button>
    );
  };

  const renderGenerateTokenButton = () => {
    if (authState || !user?.rdOAuthCode) {
      return false;
    }

    return (
      <button
        className="btn-blue-save"
        type="button"
        onClick={onClickGenerateTokenButton}
      >
        gerar token
      </button>
    );
  };

  const renderTokenOptions = () => {
    if (!authState) {
      return false;
    }

    return (
      <button
        className="btn-blue-remove"
        type="button"
        onClick={onClickRemoveTokenButton}
      >
        remover token
      </button>
    );
  };

  return (
    <div>
      <p style={{ fontSize: 20 }}>
        Configurar integração <strong>RD Station</strong>
      </p>
      {renderCustomSubTitle()}
      {renderLoginButton()}
      {renderGenerateTokenButton()}
      {renderTokenOptions()}
    </div>
  );
};

export default SettingsRDStation;
